import {Component, forwardRef, Inject, Input, OnChanges, OnDestroy, SimpleChanges} from "@angular/core";
import {DomSanitizer} from "@angular/platform-browser";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {Router} from "@angular/router";
import {SessionService} from "../../../services/session.service";
import {TranslateService} from "@ngx-translate/core";
import {PopupServices} from "../../../services/popup.services";
import {ClientService} from "../../../services/client.service";
import {Enterprise} from "../../../model/Enterprise";

@Component({
  selector: 'cgiConnect',
  templateUrl: './CgiConnectComponent.html',
  providers: []
})

export class CgiConnectComponent implements OnChanges,OnDestroy {

  @Input()
  enterprise: Enterprise;

  sessionIsActive = false;

  private _timerMemo: any;

  private _

  constructor(
    @Inject(forwardRef(() => ClientService)) private clientService: ClientService,
    @Inject(forwardRef(() => DomSanitizer)) private domSanitizer: DomSanitizer,
    @Inject(forwardRef(() => NgbModal)) private modalService: NgbModal,
    @Inject(forwardRef(() => PopupServices)) private popupServices: PopupServices,
    @Inject(forwardRef(() => Router)) private router: Router,
    @Inject(forwardRef(() => SessionService)) private session: SessionService,
    @Inject(forwardRef(() => TranslateService)) private translateService: TranslateService
  ) {

  }

  ngOnDestroy(): void {
    if (this._timerMemo){
      clearInterval(this._timerMemo);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
       this.verifyConnection();
    if (!this._timerMemo){
      this._timerMemo = setInterval(()=>{
          this.verifyConnection();
        },3*1000 // 2 sec.
      ); // 10 sec
    }



  }

    sdf

  public verifyConnection(){
    if (this.enterprise){
      this.clientService.verifyCgiConnection(this.enterprise.id).subscribe((res)=>{
        if (res.success){
          console.log(res);
          this.sessionIsActive = true;
        }else{
          console.log(res);
          this.sessionIsActive = false;
        }
      })
    }

  }

  public connectToCgi(){
    if (this.enterprise){
      this.clientService.retrieveCgiAutorizationUrl(this.enterprise.id).subscribe((res)=>{
        if (res.success){
          window.open(res.data, "_blank");
        }
      })
    }
  }


}
